import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {dateFilters, dateFilterToPeriod, User, ConfigService} from 'shared';
import {DxToolbarComponent} from 'devextreme-angular';
import {Subject, Subscription} from 'rxjs';
import {FieldsInterventionsPageRequest} from '../fields-interventions-page/fields-interventions-page-request';
import {HttpClient, HttpParams} from '@angular/common/http';

@Component({
  selector: 'app-fields-interventions-toolbar',
  templateUrl: './fields-interventions-toolbar.component.html',
  styleUrls: ['./fields-interventions-toolbar.component.scss']
})
export class FieldsInterventionsToolbarComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Input()
  request: FieldsInterventionsPageRequest;

  // loadingVisible = false;
  generateButtonOptions: any;
  dateFilters = dateFilters;
  interventionTypeFilters = [
    { value: null, label: 'Tous' },
    { value: 'trailer', label: 'Auto' },
    { value: 'reconstructed', label: 'Auto (A valider)' },
    { value: 'manual', label: 'Manuel' }
  ];
  pendingInterventionsCount = 0;
  showPendingButton = false;
  // private isLoadingSub: Subscription;

  constructor(
    public user: User,
    private http: HttpClient,
    private config: ConfigService,
  ) {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
    this.interventionTypeChanged = this.interventionTypeChanged.bind(this);
    this.showPendingInterventions = this.showPendingInterventions.bind(this);
  }

  ngOnInit() {

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: (e: any) => {
        const result = e.validationGroup.validate();
        if (result.isValid) {
          this.request.submit();
        }
      }
    };

    // Load pending interventions count if user has permission
    if (this.user.can('list reconstructed_interventions')) {
      this.loadPendingCount();
    }
  }

  loadPendingCount(): void {
    if (!this.user.can('list reconstructed_interventions')) {
      return;
    }

    // Use HTTP client directly to get count with status filter
    const params = new HttpParams()
      .set('status', 'pending_validation')
      .set('skip', '0')
      .set('take', '1'); // We only need the total count

    this.http.get<any>(this.config.apiVerUrl('/app/reconstructed-interventions'), { params })
      .subscribe({
        next: (response) => {
          this.pendingInterventionsCount = response.total || response.totalCount || 0;
          this.showPendingButton = this.pendingInterventionsCount > 0;
        },
        error: (err) => {
          console.error('Error loading pending interventions count:', err);
          this.pendingInterventionsCount = 0;
          this.showPendingButton = false;
        }
      });
  }

  showPendingInterventions(): void {
    // Set flag to show all pending interventions without date limits
    this.request.showAllPending = true;
    // Set filter to show only reconstructed interventions
    this.request.interventionType = 'reconstructed';
    // Keep current filter but clear date values so backend doesn't filter by date
    // The showAllPending flag will ensure no date filtering is applied
    this.request.from = null;
    this.request.to = null;
    this.request.isToday = false;
    // Trigger reload
    this.request.submit();
  }

  dateFilterChanged(e) {
    // Reset showAllPending flag when user changes date filter
    this.request.showAllPending = false;
    this.request.isToday = false;
    if (this.request.currentFilter === 0 || e.value === 0) {
      setTimeout(() => {
        this.toolbar.instance.repaint();
      }, 100);
    }
    this.request.currentFilter = e.value;
    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }

  interventionTypeChanged(e: any) {
    // Reset showAllPending flag when user changes intervention type
    this.request.showAllPending = false;
    this.request.interventionType = e.value;
  }

  ngAfterViewInit(): void {
    // this.isLoadingSub = this.request.loading$.subscribe(loading => this.loadingVisible = loading);
  }

  ngOnDestroy(): void {
    // this.isLoadingSub.unsubscribe();
  }
}
